import React from 'react'
import { Constants } from '@mobi/settings/constants'

export const PersonalDetailsDisclaimer = () => (
  <div>
    By clicking ‘Next’ I acknowledge and confirm that the following statements are true and correct:{' '}
    <br />
    <br />· I am 18 years of age or older; <br />
    <br />· I have read, understood and agree to RWWA’s{' '}
    <a href={Constants.TABtouchTermsAndConditions} rel='noopener noreferrer' target='_blank'>
      TABtouch Account Terms and Conditions
    </a>
    ,{' '}
    <a href='https://www.rwwa.com.au/privacy-policy/' rel='noopener noreferrer' target='_blank'>
      Privacy Collection Notice and Privacy Policy;
    </a>
    <br />
    <br />· I am authorised to provide the personal information available in this application form;
    and <br />
    <br />· I consent to my personal information being checked with the document issuer or official
    record holder via third party systems for the purpose of confirming my identity.
    <br />
    <br />
    RWWA is precluded from opening a TABtouch account for you if you do not consent to the above
    requirements.
    <br />
    <br />
    If you do not consent to the above, do not click ‘Next’.
  </div>
)
